function Compare(el) {
    this.el = el;
    this.init();
}

Compare.prototype.init = function() {
    this.sliderEl = this.el.querySelector('.jsCompareList');
    this.slideCount = this.sliderEl.querySelectorAll('.compare-product').length;
    this.prevBtnEl = this.el.querySelector('.jsPrev');
    this.nextBtnEl = this.el.querySelector('.jsNext');
    this.flickity = new Flickity(this.sliderEl, {
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        contain: false,
        imagesLoaded: true
    });

    this.setLineHeights();
    window.addEventListener('resize', () => this.setLineHeights());

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsPrev')) {
            e.preventDefault();
            this.flickity.previous();

        } else if (e.target.classList.contains('jsNext')) {
            e.preventDefault();
            this.flickity.next();
        }
    });

    this.flickity.on('change', index => {
        this.prevBtnEl.disabled = false;
        this.nextBtnEl.disabled = false;

        if (index === 0) this.prevBtnEl.disabled = true;
        if (index === this.slideCount - 1) this.nextBtnEl.disabled = true;
    });
};

Compare.prototype.setLineHeights = function() {
    for (let i = 1; i <= 9; i++) {
        const elements = this.el.querySelectorAll('[data-eh="' + i + '"]');
        let maxHeight = 0;

        [...elements].map(el => {
            el.style.height = '';
            if (el.offsetHeight > maxHeight) maxHeight = el.offsetHeight;
        });

        gsap.set(elements, { height: maxHeight });
    }

    const firstCompareProductEl = this.el.querySelector('.jsCompareProduct.first');
    const compareProductEls = this.el.querySelectorAll('.jsCompareProduct:not(.first)');
    gsap.set(compareProductEls, { width: firstCompareProductEl.offsetWidth });

    this.flickity.resize();
};

(function() {
    const complareEls = document.body.querySelectorAll('.jsCompare');
    [...complareEls].forEach(el => new Compare(el));
})();